export const RENTAL_ACCOUNT_CREATE_ATTRIBUTION = 'rent-account-create-attribution';
export const THRIFT_ACCOUNT_CREATE_ATTRIBUTION = 'thrift-account-create-attribution';

export const ACCOUNT_CREATE_ATTRIBUTION_SOURCES = 'account-create-attribution-sources';
export const ACCOUNT_CREATE_ATTRIBUTION_OTHER = 'account-create-attribution-other';
